import type { NavItem } from '../types'

export const whyPennyLane: NavItem = {
  name: 'Why PennyLane',
  linkSections: [
    {
      columns: 1,
      sections: [
        {
          header: 'About PennyLane',
          items: [
            {
              name: 'Features',
              href: '/features',
              description:
                'Discover easy-to-use PennyLane features to empower your work.',
            },
            {
              name: 'Performance',
              href: '/performance',
              description:
                'Scale up your workflows on GPUs and supercomputers to accelerate simulations.',
            },
            {
              name: 'Hardware and simulators',
              href: '/devices',
              description: `Explore PennyLane's quantum device ecosystem with 40+ integrated options.`,
            },
          ],
        },
      ],
    },
    {
      columns: 1,
      sections: [
        {
          header: 'Use Cases & Applications',
          items: [
            {
              name: 'Research',
              href: '/research',
              description:
                'Accelerate your quantum computing research breakthroughs with PennyLane.',
            },
            {
              name: 'Teach',
              href: '/education',
              description:
                'Join quantum educators in over 150 universities using PennyLane in the classroom.',
            },
            {
              name: 'Learn',
              href: '/learn',
              description:
                'Delve into quantum computing, quantum chemistry, and quantum machine learning.',
            },
          ],
        },
      ],
    },
  ],
  cardSections: [
    {
      header: 'Featured',
      type: 'featured',
      cards: [
        {
          variant: 'white',
          title: 'Research',
          description: `Use **the world’s largest quantum demo library** to publish breakthrough research.`,
          imageSrc:
            'https://assets.cloud.pennylane.ai/navbar/why-pennylane-research-small.png',
          imageSize: 'small',
          button: {
            text: 'Research with PennyLane',
            variant: 'primary',
          },
          href: '/research',
        },
        {
          variant: 'white',
          title: 'Teach',
          description: `Elevate your curriculum using **industry-standard tools** that build job-ready skills.`,
          imageSrc:
            'https://assets.cloud.pennylane.ai/navbar/why-pennylane-teach-small.png',
          imageSize: 'small',
          button: {
            text: 'Explore educator resources',
            variant: 'primary',
          },
          href: '/education',
        },
      ],
    },
  ],
}
